import yup from '@/utils/yup-global'

export const checkoutStep1Schema = yup.object().shape({
  name: yup.string().required('Please enter your name'),
  email: yup.string().email('Invalid email').required('Please enter your email'),
  phone: yup
    .string()
    .required('Please enter your phone')
    .onlyNumber('Invalid number')
    .phoneNumber('Invalid phone'),
  address: yup.string().required('Please enter your address'),
  note: yup.string(),
  rule: yup.boolean().required('Please agree with our policy'),
  city_id: yup.number().required('Please select city'),
  district_id: yup.number().required('Please select district'),
  ward_id: yup.number().required('Please select ward'),
  payment: yup.string().notRequired(),
})

export const trackingOrderSchema = yup.object().shape({
  orderId: yup.string().required('Vui lòng nhập mã đơn hàng'),
  emailOrPhone: yup
    .string()
    .required('Vui lòng nhập số điện thoại hoặc email')
    .matches(
      /^([a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+|0\d{9})$/,
      'Email hoặc số điện thoại không đúng định dạng'
    ),
})
